import React, { Component } from 'react';
import { withStyles } from 'material-ui';
import List, { ListItem, ListItemText } from 'material-ui/List';
import Dictionary from '../../../../model/Dictionary';
import styles from './MealsListStyles';
import MealsListProps from '../../common/mealsList/MealsListProps';
import MealsListController from '../../common/mealsList/MealsListController';
import ProgressBarCenter from '../../../../components/ProgressBarCenter';
import SelectedMealListItems from '../../common/mealsList/SelectedMealListItems';
import NoSelectedMealItem from '../../../../components/meals/selectedMealListItem/NoSelectedMealItem';
import Constants from '../../../../model/AppConfiguration';

/**
 * ## Redux imports
 */
import * as passengersActions from '../../../../redux/actions/PassengersActions';
import * as flightsActions from '../../../../redux/actions/FlightsActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../../../redux/selectors/Index';

class MealsList extends Component {
  static propTypes = MealsListProps;

  constructor (props) {
    super(props);

    const { reservationId, passengers, flights, actions } = props;
    if (reservationId && (!passengers || !passengers.length)) {
      actions.getPassengers(reservationId);
    }

    this.state = {
      routeId: '',
      checked: [ 0 ],
      passengers: passengers || [],
      meals: [],
      selectedMeals: [],
      flights: flights || [],
    };

    this.selectPassenger = MealsListController.selectPassenger.bind(this);
    this.onRouteIdChange = MealsListController.onRouteIdChange.bind(this);
  }

  componentDidMount () {
    let { flights, isFetching, reservationId, actions } = this.props;

    if (!isFetching && !flights) {
      actions.getFlights(Constants.REQUEST.MEALS, reservationId);
    }
  }

  componentWillReceiveProps (props) {
    let { flights, routeId, isFetching } = props;

    if (!isFetching && (routeId !== this.state.routeId || flights !== this.props.flights)) {
      this.onRouteIdChange(props);
    }
  }

  onListItemClick = passenger => {
    const { selectable, onItemClickAction } = this.props;
    if (!selectable && onItemClickAction) {
      onItemClickAction(passenger.id);
      return;
    }
    this.selectPassenger(passenger.id);
  };

  render () {
    const { classes, activePassenger, isFetching } = this.props;
    const { flights, selectedMeals, meals } = this.state;

    if (isFetching && !selectedMeals && (!flights && !flights.length)) {
      return <ProgressBarCenter />;
    }

    if (flights && !flights.length) {
      return <h3 style={{ margin: 30 }}>{Dictionary.flights.noFlightsAvailable}</h3>;
    }

    if (!selectedMeals.length) {
      return <h3 style={{ margin: 30 }}>{Dictionary.passengers.noSelectedPassengers}</h3>;
    }

    let className =
      meals && meals.category && meals.category.length ?
        `col-${12 / (meals.category.length + 1)}` :
        '';

    return (
      <div>
        <List
          style={{ width: '100%', backgroundColor: 'transparent' }}
          className={`meals-list ${classes.root}`}
        >
          {selectedMeals.map(passenger => (
            <ListItem
              key={`selected-meal-list-item-passenger-${passenger.id}`}
              dense
              button
              onClick={() => this.onListItemClick(passenger)}
              className={`${classes.listItem} ${
                passenger.id === activePassenger ? classes.active : ''
              }`}
            >
              <ListItemText className={className} primary={passenger.fullName} />

              <NoSelectedMealItem passenger={passenger} className={className} />

              <SelectedMealListItems meals={meals} className={className} passenger={passenger} />
            </ListItem>
          ))}
        </List>
      </div>
    );
  }
}

/**
 * ## Redux boilerplate
 */
const actions = [ passengersActions, flightsActions ];

function mapStateToProps (state) {
  let JSFlights = selectors.flights.getFlights(state.flights);
  return {
    isFetching: selectors.global.isFetching(state.global),
    reservationId: selectors.general.getReservationId(state.general),
    passengers: selectors.passengers.getPassengers(state.passengers),
    flights: selectors.flights.pairSeatsForPassengers(JSFlights),
  };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MealsList));



// WEBPACK FOOTER //
// ./src/containers/meals/desktop/mealsList/MealsList.js